import { type ReactNode } from 'react';
import { getRepubMetaFromRepub } from '@cx-web/utils';
import classNames from 'classnames';

import { type Repub } from '@cx-modules/types';

import { getPlusLinks, PLUS_REPUB_CONFIG } from '~/configuration/repub';
import { Button } from '~/vendor/cxy/components/Button';

import styles from './styles/HeaderItems.module.scss';

type LinkItem = {
  className: string;
  href: string;
  link: ReactNode;
};

export const HeaderItems = ({
  baseUrl,
  currentPathWithRepub,
  isTipstersEnabled,
  repub,
  resourcesUrl,
}: {
  baseUrl: string;
  currentPathWithRepub: string;
  isTipstersEnabled: boolean;
  repub: Repub;
  resourcesUrl: string;
}) => {
  const urlPrefix = `${PLUS_REPUB_CONFIG[repub]?.plusHomePagePath ?? ''}/`;

  const getLinks = () => getPlusLinks({ repub, isTipstersEnabled, urlPrefix });
  const { repubIs } = getRepubMetaFromRepub(repub);

  const logoConfig = PLUS_REPUB_CONFIG[repub]?.logo;

  const logoURL = () => {
    if (PLUS_REPUB_CONFIG[repub]?.logoUrl) {
      return PLUS_REPUB_CONFIG[repub]?.logoUrl;
    }
    return repubIs.GZ ? baseUrl + 'plus' : baseUrl;
  };

  const logoItem = logoConfig
    ? {
        href: logoURL(),
        className: styles.logo,
        link: (
          <picture className={styles.pictureWrapper}>
            {logoConfig.mobileSrc && <source media="(max-width: 1024px)" srcSet={logoConfig.mobileSrc(resourcesUrl)} />}
            <img
              alt={logoConfig.alt}
              className={styles.logoImage}
              src={logoConfig.src(resourcesUrl)}
              style={logoConfig.style}
            />
          </picture>
        ),
      }
    : null;

  const links = [...(logoItem ? [logoItem] : []), ...getLinks()] as LinkItem[];

  return (
    <ul className={styles.links}>
      {Object.values(links).map((item, index) => (
        <li
          className={classNames(styles.linkItem, currentPathWithRepub === item.href ? styles.isSelected : null, {
            [item.className]: item.className,
          })}
          key={`navigation-item-${index}`}
        >
          <Button asChild size="large">
            <a href={item.href}>{item.link}</a>
          </Button>
        </li>
      ))}
    </ul>
  );
};
